import { render, staticRenderFns } from "./zaixian.vue?vue&type=template&id=6adb3aec&scoped=true&"
import script from "./zaixian.vue?vue&type=script&lang=js&"
export * from "./zaixian.vue?vue&type=script&lang=js&"
import style0 from "./zaixian.vue?vue&type=style&index=0&id=6adb3aec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6adb3aec",
  null
  
)

export default component.exports